









































import { defineComponent, computed } from '@vue/composition-api'

import { AppInput, AppIcon, MasterAutocomplete } from '@/components/atoms'
import { ISpecialOffer, ISpecialOfferReceipt } from '@/types/special-offer'

type Props = {
  specialOffer: ISpecialOffer
  specialOfferReceipt: ISpecialOfferReceipt
}

export default defineComponent({
  name: 'SpecialOfferTable',
  components: { AppInput, AppIcon, MasterAutocomplete },
  props: {
    specialOffer: {
      type: Object,
      default: () => ({}),
    },
    specialOfferReceipt: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props: Props) {
    const details = computed(() => {
      return [
        {
          label: 'OKリンカーID',
          value: props.specialOfferReceipt.okedByLinkerId,
        },
        {
          label: 'NGリンカーID',
          value: props.specialOfferReceipt.ngedByLinkerId,
        },
        {
          label: 'OKリーダーID',
          value: props.specialOfferReceipt.okedByLeaderId,
        },
        {
          label: 'NGリーダーID',
          value: props.specialOfferReceipt.ngedByLeaderId,
        },
      ]
    })
    const metas = computed(() => {
      return [
        {
          label: 'ID',
          value: props.specialOffer.id,
        },
        {
          label: '管理名',
          value: props.specialOffer.nameAdmin,
        },
        {
          label: 'productName',
          value: props.specialOffer.productName,
        },
        {
          label: 'productName(2)',
          value: props.specialOffer.productNameSecond,
        },
        {
          label: 'title',
          value: props.specialOffer.title,
        },
        {
          label: 'offerInformation',
          value: props.specialOffer.offerInformation,
        },
        {
          label: 'aboutProduct',
          value: props.specialOffer.aboutProduct,
        },
        {
          label: 'productSiteUrl',
          value: props.specialOffer.productSiteUrl,
        },
        {
          label: 'companyName',
          value: props.specialOffer.companyName,
        },
        {
          label: 'targetAgeText',
          value: props.specialOffer.targetAgeText,
        },
        {
          label: 'targetPurchasePeriodText',
          value: props.specialOffer.targetPurchasePeriodText,
        },
      ]
    })

    return {
      details,
      metas,
    }
  },
})
